/*
    How a note's date reads, in one place (MPN-1640).

    The Notes page has shown a date beside each note since MPN-1640; the Monitor page's
    Recent Notes tile showed only titles, so the same note was dated in one view and
    undated in the other. The tile is where someone checks what changed on a campaign
    and when, which is exactly the question a bare list of titles cannot answer -- Ops
    had taken to typing the date into the title ("9/1 Reduced Meta bid from $20 to $15")
    to work around it.

    Shared rather than copied so the two views cannot drift into formatting the same
    date two ways.
*/
export function formatNoteDate(value: string | null | undefined): string | null {
  if (!value) return null
  const d = new Date(value)
  // Notes written before create_date was exposed still have one, so this only guards a
  // value the API could not parse.
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
}
